export default __webpack_public_path__ + "static/media/slider3.a0f23d22.jpg";